export default __webpack_public_path__ + "static/card-visa-platinum@2x-9d634fce828b08b12301e64c9926cec4.png";